module.exports = __webpack_public_path__ + "static/media/S1_00014.3229fe67.jpg";